<template>
    <h2 class="center">Totalt</h2>
    <p v-if="!current" class="regtable__empty">Laster...</p>
    <template v-else>
        <div class="mypage__stats">
            <div class="mypage__stat">
                <div class="mypage__statcount">{{ current.stats.n_routes }}</div>
                <div class="mypage__stat-text">Turmål</div>
            </div>
            <div class="mypage__stat">
                <div class="mypage__statcount">{{ current.stats.n_regs }}</div>
                <div class="mypage__stat-text">Registreringer</div>
            </div>
            <div class="mypage__stat-break"></div>
            <div v-if="current.stats.total_distance > 0" class="mypage__stat">
                <div class="mypage__statcount">{{ formatDistance(current.stats.total_distance) }}</div>
                <div class="mypage__stat-text">Kilometer</div>
            </div>
            <div v-if="current.stats.total_elevation > 0" class="mypage__stat">
                <div class="mypage__statcount">{{ current.stats.total_elevation }}</div>
                <div class="mypage__stat-text">Høydemeter</div>
            </div>
        </div>

        <div class="regtable__wrapper">
            <h2 class="center">Registrerte turer</h2>
            <ul v-if="current.registrations.length" class="regtable__list">
                <li v-for="(reg, index) in current.registrations" :key="reg.route_id + '-' + reg.route_date" class="regtable__item" :id="'reg-' + reg.person_id + '-' + (index + 1)">
                    <div class="regtable__body">
                        <div class="regtable__headline">
                            <img class="regtable__grade-icon" :src="'/icons/grade_' + (current.winter ? 1 : 0) + '_' + reg.grade_num + '.svg'" :alt="reg.grade_out" aria-hidden="true">
                            <span>{{ reg.name }}</span>
                        </div>
                        <div class="regtable__secondary">
                            <span>{{ reg.date_out }}</span>
                            <span class="regtable__municipality">{{ reg.municipality }}</span>
                            <span v-if="reg.distance" class="regtable__stat">
                                <svg class="regtable__icon" viewBox="0 0 283.6 283.1" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill="currentColor" d="M169,47.7c-0.1,9.8-8.1,17.7-17.9,17.6c-9.8-0.1-17.7-8.1-17.6-17.9c0.1-9.8,8-17.6,17.8-17.6C161.1,29.8,169.1,37.8,169,47.7z"/><path fill="currentColor" d="M123.2,67c0,0-12-7.7-22.8-1.6c-9.9,5.5-20.2,38.1-17.4,52.1c2.2,11,17.4,13.7,17.4,13.7L123.2,67z"/><path fill="currentColor" d="M199.8,136l-27.9-21.6L158,90.8c0-0.1,0-0.1,0-0.2c0.3-16.5-8.2-19.5-8.2-19.5c-3.3-1.8-15.1-6.8-19.3-0.3c-3.7,5.7-21.7,61.4-22.6,64.8c-1.1,4-0.4,11.1,0.4,22.2c0.1,1.9-4.2,36-5.4,41c-2.8,11.4-8.7,44.7-9,45.8c-2.2,9.9,13.3,14,16.6,3.3c1.4-4.5,11.9-35.5,23.1-72.4c0.1-0.5,20.9,31.6,21.6,32.5c0.6,0.9,9.4,38.5,9.6,38.9c3.6,11.7,18.5,10,16.1-4.5c-1.2-6.9-5.5-38.7-8.9-49.2c-1.6-5-25.4-44.6-25-46.5c0.4-1.8,3.8-20.3,5.6-29.9l11.2,11.6c1.7,1.1,29.7,17.4,29.7,17.4C198.9,150,206.6,142,199.8,136z"/></svg>
                                {{ reg.distance }} km
                            </span>
                            <span v-if="reg.maptrack" class="regtable__stat">
                                <svg class="regtable__icon" viewBox="0 0 16 14" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><polygon points="8,1 15,13 1,13" fill="currentColor"/></svg>
                                {{ reg.elevation }} hm
                            </span>
                        </div>
                    </div>
                    <div class="regtable__meta">
                        <div class="regtable__delete"><a href="#" @click.prevent="confirmDelete(reg)" title="Slett registreringen"></a></div>
                    </div>
                </li>
            </ul>
            <p v-else class="regtable__empty">Ingen registreringer</p>
            <a v-if="!current.showAll && current.registrations.length === current.limit" href="#" @click.prevent="loadAll" class="regtable__showall">Se hele listen</a>

            <template v-if="current.registrationsTop.length">
                <h2 class="center">Mest besøkte turer</h2>
                <ul class="regtable__list">
                    <li v-for="reg in current.registrationsTop" :key="reg.name" class="regtable__item">
                        <div class="regtable__body">
                            <div class="regtable__headline">
                                <img class="regtable__grade-icon" :src="'/icons/grade_' + (current.winter ? 1 : 0) + '_' + reg.grade_num + '.svg'" :alt="reg.grade_out" aria-hidden="true">
                                <span>{{ reg.name }}</span>
                            </div>
                            <div class="regtable__secondary">
                                <span class="regtable__municipality">{{ reg.municipality }}</span>
                                <span v-if="reg.distance" class="regtable__stat">
                                    <svg class="regtable__icon" viewBox="0 0 283.6 283.1" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill="currentColor" d="M169,47.7c-0.1,9.8-8.1,17.7-17.9,17.6c-9.8-0.1-17.7-8.1-17.6-17.9c0.1-9.8,8-17.6,17.8-17.6C161.1,29.8,169.1,37.8,169,47.7z"/><path fill="currentColor" d="M123.2,67c0,0-12-7.7-22.8-1.6c-9.9,5.5-20.2,38.1-17.4,52.1c2.2,11,17.4,13.7,17.4,13.7L123.2,67z"/><path fill="currentColor" d="M199.8,136l-27.9-21.6L158,90.8c0-0.1,0-0.1,0-0.2c0.3-16.5-8.2-19.5-8.2-19.5c-3.3-1.8-15.1-6.8-19.3-0.3c-3.7,5.7-21.7,61.4-22.6,64.8c-1.1,4-0.4,11.1,0.4,22.2c0.1,1.9-4.2,36-5.4,41c-2.8,11.4-8.7,44.7-9,45.8c-2.2,9.9,13.3,14,16.6,3.3c1.4-4.5,11.9-35.5,23.1-72.4c0.1-0.5,20.9,31.6,21.6,32.5c0.6,0.9,9.4,38.5,9.6,38.9c3.6,11.7,18.5,10,16.1-4.5c-1.2-6.9-5.5-38.7-8.9-49.2c-1.6-5-25.4-44.6-25-46.5c0.4-1.8,3.8-20.3,5.6-29.9l11.2,11.6c1.7,1.1,29.7,17.4,29.7,17.4C198.9,150,206.6,142,199.8,136z"/></svg>
                                    {{ reg.distance }} km
                                </span>
                                <span v-if="reg.maptrack" class="regtable__stat">
                                    <svg class="regtable__icon" viewBox="0 0 16 14" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><polygon points="8,1 15,13 1,13" fill="currentColor"/></svg>
                                    {{ reg.elevation }} hm
                                </span>
                            </div>
                        </div>
                        <div class="regtable__meta">
                            <span class="regtable__visits">{{ reg.n_regs }}×</span>
                        </div>
                    </li>
                </ul>
                <a v-if="!current.showTop && current.registrationsTop.length === current.limitTop" href="#" @click.prevent="loadAllTop" class="regtable__showall">Se hele listen</a>
            </template>
        </div>
    </template>

    <div class="st-modal" :class="{ 'st-modal--active': !!deleteTarget }">
        <div class="st-modal__content">
            <div class="st-modal__header">
                <div class="hero__header">Slett registrering</div>
            </div>
            <div v-if="deleteTarget" class="st-modal__text">
                <p>Vil du slette registreringen av <strong>{{ deleteTarget.name }}</strong> ({{ deleteTarget.date_out }})?</p>
                <div class="mypage__editbar">
                    <button type="button" class="action" :disabled="deleting" @click="performDelete">{{ deleting ? 'Sletter...' : 'Slett' }}</button>
                    <button type="button" class="action action--hollow" :disabled="deleting" @click="deleteTarget = null">Avbryt</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
    current: { type: Object, default: null },
    loadAll: { type: Function, required: true },
    loadAllTop: { type: Function, required: true },
    deleteRegistration: { type: Function, required: true },
});

function formatDistance(distance) {
    return distance.toFixed(1).replace('.', ',');
}

// Confirm-then-delete - performDelete() calls back up to MyPageCard.vue,
// which owns the shared per-member/year cache and does the actual fetch.
const deleteTarget = ref(null);
const deleting = ref(false);

function confirmDelete(reg) {
    deleteTarget.value = reg;
}

async function performDelete() {
    if (!deleteTarget.value) {
        return;
    }

    deleting.value = true;
    try {
        await props.deleteRegistration(deleteTarget.value);
    } finally {
        deleting.value = false;
        deleteTarget.value = null;
    }
}
</script>
